import React from 'react';
import { Button, Dialog, Grid, Icon, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Scrollbars from 'rc-scrollbars';
import SearchGrid from '../../../components/table/SearchGrid';
import { DraggableComponent } from '../../../components/UiElements/UiElements';
import useStyles from './styles';

function AssignmentHistory({ dialogOpenClose, handleClose, history, ...props }) {
    const classes = useStyles();

    return (
        <Dialog
            classes={{ paper: classes.dialogPaper }}
            PaperComponent={DraggableComponent}
            disableBackdropClick
            disableEscapeKeyDown
            open={dialogOpenClose}
            maxWidth="lg"
            {...props}
        >
            <div className={classes.dialogContent}>
                <div className={classes.box}>
                    <div className={classes.header} id="draggable-dialog-title">
                        <Typography className={classes.title}>Assignment History</Typography>
                        <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                    </div>
                    <Scrollbars autoHeight autoHeightMax="calc(90vh - 150px)">
                        <div className={classes.content}>
                            <Grid row className={classes.container}>
                                <div className={classes.historyTableWrapper}>
                                    <SearchGrid
                                        columns="assignmentHistory"
                                        list={history}
                                        noRecordMsg="No record exists"
                                        Icon={true}
                                        isSearchAble={false}
                                    />
                                </div>
                            </Grid>
                        </div>
                    </Scrollbars>
                    <div className={classes.footer}>
                        <div className={classes.footerRight}>
                            <Button className={classes.backBtn} onClick={handleClose}>Close</Button>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default AssignmentHistory;
